import { AIResponse } from '@landtrustinc/design-system';

import type { BuckChatWelcomeContent } from '../../types';

type BaseEmptyStateProps = {
  content?: BuckChatWelcomeContent;
  defaultContent?: BuckChatWelcomeContent;
  disabled?: boolean;
  onPromptClick?: (prompt: string) => void;
  starterPromptsTitle?: string;
};

const buildEmptyStateBody = (content: BuckChatWelcomeContent) => {
  if (content.subheading && content.introBody) {
    return (
      <>
        {content.subheading} {content.introBody}
      </>
    );
  }

  return content.introBody ?? content.subheading;
};

const BaseEmptyState = ({ content, defaultContent }: BaseEmptyStateProps) => {
  const baseContent = defaultContent ?? {};
  const resolvedContent: BuckChatWelcomeContent = {
    ...baseContent,
    ...content,
    starterPrompts: content?.starterPrompts ?? baseContent.starterPrompts,
    widgetEmptyState: content?.widgetEmptyState ?? baseContent.widgetEmptyState,
  };

  return (
    <AIResponse
      title={resolvedContent.heading ?? 'Have a question?'}
      showDisclaimer={false}
      showHelpfulQuestion={false}
    >
      {buildEmptyStateBody(resolvedContent)}
    </AIResponse>
  );
};

export default BaseEmptyState;
